import {connect} from 'react-redux';
import TurboCashOfferView from '../../../components/views/mx/creditoReal/TurboCashOfferView';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {TurboCashOfferDispatchProps, TurboCashOfferStateProps} from '../../../types/mx/creditoReal/containers';
import {CatalogsHeadlessGraphCms} from '../../../types/mx/catalog';
import {isWebDevice} from '../../../utils/ValidationUtils';

const mapStateToProps = (state): TurboCashOfferStateProps => {
    const catalogs: CatalogsHeadlessGraphCms = state.catalogs.headlessGraphCms;
    const {title, descriptionHtml, descriptionStyledHtml, descriptionText, descriptionStyledText} = catalogs.offers
        .find(item => isWebDevice(item.source)) ||
    {title: '', descriptionHtml: '', descriptionStyledHtml: '', descriptionText: '', descriptionStyledText: ''};
    const message: string = `${descriptionText} ${descriptionStyledText}`;

    return {
        message,
        title,
        descriptionHtml,
        descriptionStyledHtml
    };
};

const mapDispatchToProps = (dispatch): TurboCashOfferDispatchProps => {
    return {
        onAcceptOffer: (msg: string) => () =>
            dispatch(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.action(true, msg, true)),
        onRefuseOffer: (msg: string) => () =>
            dispatch(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.action(false, msg)),
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const msg: string = stateProps.message;
    return {
        ...stateProps,
        ...dispatchProps,
        onAcceptOffer: dispatchProps.onAcceptOffer(msg),
        onRefuseOffer: dispatchProps.onRefuseOffer(msg)
    };
};

const TurboCashOfferContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(TurboCashOfferView));

export default TurboCashOfferContainer;